import React from "react";
import { Link } from "react-router-dom";
import { formatCents } from "../../marketplace/shopApi";
import type { Product } from "../../marketplace/shopApi";
import type { AotdDay } from "../printsApi";
import { formatPriceCents } from "../printProducts";
import type { FormatInfo, PrintEdition } from "../printProducts";
import { FitFace } from "./FitFace";

// A small card for one print of today's AOTD, in the look of the store's product cards: the flat
// print face on paper-grey, the name and the price. Originals get the foil sheen and no price.

export const PrintTile: React.FC<{
  day: AotdDay;
  info: FormatInfo;
  edition: PrintEdition;
  products: Product[];
  to: string;
  index: number;
  tag?: string;
}> = ({ day, info, edition, products, to, index, tag }) => {
  const original = edition === "original";
  return (
    <li className={`sf-card tp-tile ${original ? "tp-tile--og" : ""}`} style={{ "--i": index } as React.CSSProperties}>
      <Link to={to} className="sf-card-link">
        <div className="sf-card-media tp-tile-media">
          <FitFace day={day} format={info.format} edition={edition} fill={0.74} />
          {original && <span className="tp-og-sheen" aria-hidden="true" />}
          {tag && <span className="sf-tag">{tag}</span>}
        </div>
        <div className="sf-card-body">
          <h3 className="sf-card-name">{original ? `original ${info.name}` : info.name}</h3>
          <p className="sf-card-price">{original ? "1 of 1" : formatCents(formatPriceCents(products, info, edition), "EUR")}</p>
        </div>
      </Link>
    </li>
  );
};

export default PrintTile;
